angular.module('picmonicng').directive('postlearnBar', [
  'LearnService',
  '$interval',
  '$state',
  '$filter',
  '$stateParams',
  'BrowseService',
  '$timeout',
  'UserService',
  'TokenService',
  '$modal',
  function (
    LearnService,
    $interval,
    $state,
    $filter,
    $stateParams,
    BrowseService,
    $timeout,
    UserService,
    TokenService,
    $modal
  ) {
    return {
      restrict: 'E',
      replace: true,
      transclude: true,
      template:
        '<div class="postlearn-bar" ng-class="{\'open\':open}" ng-click="$event.stopPropagation()" ng-transclude></div>',
      link: function (scope, element, attrs) {
        scope.LearnService = LearnService;
        scope.time_remaining = 8;
        scope.paused = false;
        scope.card = LearnService.currentCard;
        scope.window = window;
        scope.open = false;

        // Focus the start quiz, play, or pause button (whichever is displayed first)
        $timeout(function () {
          element.find('.postlearn-button:first').focus();
          scope.open = true;
        }, 1000);

        if (scope.interval) {
          $interval.cancel(scope.interval);
        }

        if (!BrowseService.browseOpen) {
          scope.interval = $interval(function () {
            if (scope.windowHasFocus && !BrowseService.browseOpen) {
              scope.time_remaining -= 1;

              if (LearnService.modalInstance) {
                $interval.cancel(scope.interval);
                scope.paused = true;
                return;
              }

              if (scope.time_remaining <= 0) {
                $interval.cancel(scope.interval);

                switch (LearnService.postLearnAction()) {
                  case 'switch_then_quiz':
                    // If it matches the user's default audio setting then we should play the other audio
                    if (
                      LearnService.audioMode === 'educational' &&
                      LearnService.currentCard.audio.story &&
                      LearnService.currentCard.audio.educational
                    ) {
                      LearnService.toggleAudioMode();
                    } else {
                      scope.goToQuiz();
                    }
                    break;
                  case 'quiz':
                    scope.goToQuiz();
                    break;
                  case 'nothing':
                  default:
                    break;
                }
              }
            }
          }, 1000);
        } else {
          scope.paused = true;
        }

        scope.closeAndDisable = function () {
          scope.open = false;
          LearnService.closePostBar();
          LearnService.postBarEnabled = false;
        };

        scope.close = function () {
          scope.open = false;
          LearnService.closePostBar();
        };

        scope.$on('$destroy', function () {
          scope.pause();
        });

        scope.goToQuiz = function () {
          if (UserService.user.user_id || scope.embed) {
            if (window.innerWidth < 767) {
              $state.go('app.quiz', {
                quiz_type: 'picmonic',
                resource_id: scope.card.slug,
              });
            } else {
              scope.close();
              LearnService.startQuiz();
            }
          } else {
            $modal.open({
              templateUrl: '/templates/modals/register-modal.html',
              windowClass: 'registration-cta-modal full-screen-modal',
              backdropClass: 'below-nav modal-body-reduced',
              scope: scope,
              backdrop: 'static',
              controller: 'RegisterModalController',
              resolve: {
                card: function () {
                  return null;
                },
                market_id: function () {
                  return null;
                },
                copy: function () {
                  return null;
                },
                redirect: function () {
                  return '/quiz/picmonic/' + LearnService.currentCard.slug;
                },
                extraParams: function () {
                  return null;
                },
              },
            });
          }
        };

        angular.element('body').bind('click.postbar', function (event) {
          scope.$apply(function () {
            scope.pause();
            scope.close();
          });
        });

        scope.pause = function () {
          scope.paused = true;
          angular.element('body').unbind('click.postbar');
          if (scope.interval) {
            $interval.cancel(scope.interval);
          }
        };
      },
    };
  },
]);
